import api from "../../apiClient";

/**
 * admin/Review
 */

export const getAdminReviewList = async (pageNum, count) => {
    console.log("@getAdminReviewList", pageNum, count);
    const response = await api.get(`/admin/review/list?page_num=${pageNum}&count=${count}`);
    console.log(response.data.data);
    return response.data;
};

export const getAdminReviewDetail = async (idx) => {
    console.log("@getAdminReviewDetail");
    const response = await api.get(`/admin/review/${idx}`);
    console.log(response.data.data);
    return response.data;
};

// export const getAdminReviewReviewee = async (idx) => {
//     const response = await api.get(`/admin/review/${idx}/reviewee/list`);
//     console.log("@getAdminReviewReviewee", response.data.data);
//     return response.data;
// };
export const getAdminReviewReviewee = async (idx) => {
    const response = await api.get(`/admin/review/${idx}/reviewee/list`);
    console.log("@getAdminReviewReviewee (avg 가공 전)", response.data.data);

    const rawList = response.data.data;
    const formattedList = rawList.map(item => ({
        ...item,
        avg: item.avg == null ? '? ' : Number(item.avg).toFixed(2),
    }))
    console.log("@getAdminReviewReviewee (avg 가공 후)", formattedList);
    
    return { ...response.data, data: formattedList };
};

export const modifyReviewStatus = async (data) => {
    console.log("@modifyReviewStatus");
    const response = await api.put(`/admin/review/${data.reviewIdx}/status`, { status: data.status });
    return response.data;
};

export const createReview = async (data) => {
    console.log("@createReview");
    const response = await api.post(`/admin/review`, data);
    return response.data;
};

export const modifyReview = async (data) => {
    console.log("@modifyReview");
    const response = await api.put(`/admin/review`, data);
    return response.data;
};

export const deleteReview = async (idx) => {
    console.log("@deleteReview");
    const response = await api.delete(`/admin/review`, {
        data: { idx: idx },
    });
    return response.data;
};

export const getAdminReviewResultList = async (pageNum, count) => {
    console.log("@getAdminReviewResultList");
    const response = await api.get(`/admin/review/result/list?page_num=${pageNum}&count=${count}`);
    console.log(response.data.data);
    return response.data;
};

export const getAdminReviewResultDetail = async (reviewIdx, revieweeIdx) => {
    console.log("@getAdminReviewResultDetail", reviewIdx);
    const response = await api.get(`/admin/review/result/${reviewIdx}/${revieweeIdx}/detail`);
    console.log(response.data.data);
    return response.data;
};